interface ServerErrorMetadata {
  // @ts-ignore
  // @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export class ServerError extends Error {
  private metadata: ServerErrorMetadata;

  constructor(message: string, metadata: ServerErrorMetadata) {
    super(message);
    this.name = 'ServerError';
    this.metadata = metadata;

    Object.setPrototypeOf(this, ServerError.prototype);
  }

  toString(): string {
    try {
      return JSON.stringify(this.metadata);
    } catch (e) {}

    return '';
  }
}
